import { AccordionContainer, Accordion, PageSection } from "@app/shared";
import React from "react";
import { UploadTagsWizardStepProps } from "./types";

class UploadTagsWizardReview extends React.Component<UploadTagsWizardStepProps> {
  // React Built-Ins
  constructor(props: UploadTagsWizardStepProps) {
    super(props);
  }

  public render() {
    const { reviewData } = this.props;

    return (
      <PageSection>
        <div className="container">
          <AccordionContainer>
            <Accordion
              defaultOpen={true}
              testId="upload-tags-wizard-review__results-summary"
              title="Results Summary"
            >
              {`There will be ${reviewData.numTags} tag${reviewData.numTags != 1 ? "s" : ""} added to ${reviewData.numProjects} project${reviewData.numProjects != 1 ? "s" : ""} by this action.`}
            </Accordion>
          </AccordionContainer>
          {reviewData.tagGroups.map((tg) => (
            <AccordionContainer
              key={`upload-tags-wizard-review__tag-group-accordion__${tg.name.replaceAll(" ", "-").toLowerCase()}`}
            >
              <Accordion
                testId={`upload-tags-wizard-review__tag-group__${tg.name.replaceAll(" ", "-").toLowerCase()}`}
                title={`${tg.name}  (${tg.tagNames.length} tag${tg.tagNames.length != 1 ? "s" : ""})`}
              >
                <ul>
                  {
                    tg.tagNames.map((t) => (
                      <li key={`upload-tags-wizard-review__tag-group__${tg.name.replaceAll(" ", "-").toLowerCase()}__${t.replaceAll(" ", "-").toLowerCase()}`}>{t}</li>
                    ))
                  }
                </ul>
              </Accordion>
            </AccordionContainer>
          ))}
        </div>
      </PageSection>
    );
  }
}

export default UploadTagsWizardReview;
